<div class="product-loading">
  <skeleton-loading class="status-loading" />
</div>
